import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HttpModule } from '@angular/http';

// ROUTING  ---------------------------------------------------------------
import { ShareModule } from '@asambleas-modules/share/share.module';
import { appRouting } from "./app.routing";
import { HttpClientModule } from '@angular/common/http';

// SERVICES/SERVICIOS  ----------------------------------------------------
import { GeneralService } from './services/general/general.service';
import { LoadService } from './components/loader/loader.service';
import { ValidatorService } from './services/validators/validator.service';
import { FiltersService } from './services/filters/filters.service';
import { ChurchService } from './services/church/church.service';
import { RegistrationService } from './services/registration/registration.service';
import { LoginService } from './services/login/login.service';
import { MinisterService } from './services/minister/minister.service';
import { IglesiasService } from './services/iglesias/iglesias.service';

// GUARDS/GUARDAS  --------------------------------------------------------
import { LoginGuard } from './guards/login.guard';
import { GuestGuard } from './services/guards/guest.guard';

// COMPONENTS/COMPONENTES  ------------------------------------------------
import { AppComponent } from './app.component';
import { LoaderComponent } from './components/loader/loader.component';
import { AlertComponent } from './components/alert/alert.component';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { ModalLoginComponent } from './components/modals/modal-login/modal-login.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { Register2Component } from './pages/register-2/register-2.component';
import { Register1Component } from './pages/register-1/register-1.component';
import { MapComponent } from './components/map/map.component';
import { ModalRestorePasswordComponent } from './components/modals/restore-password/restore-password.component';
import { RestorePasswordComponent } from './pages/restore-password/restore-password.component';
import { UserFormModalComponent } from './components/modals/user-form-modal/user-form-modal.component';
import { RequireChurchComponent } from './components/modals/require-church/require-church.component';
import { NotificationsService } from './services/notifications/notifications.service';
import { RolesService } from '@asambleas-services/roles/roles.service';
import { InputTextComponent } from './components/input-text/input-text.component';
import { CredentialRenovationsService } from '@asambleas-services/credential-renovations.service';
import { PersoneriaJuridicaService } from '@asambleas-services/personeria-juridica/personeria-juridica.service';
import { ChurchAvatarPipe } from './pipes/church-avatar.pipe';

@NgModule({
    entryComponents: [
        ModalLoginComponent,
        ModalRestorePasswordComponent,
        LoaderComponent,
        ConfirmComponent,
        AlertComponent,
        UserFormModalComponent,
        RequireChurchComponent,
        InputTextComponent
    ],
    declarations: [
        AppComponent,
        LoaderComponent,
        AlertComponent,
        ConfirmComponent,
        ModalLoginComponent,
        LoginComponent,
        RegisterComponent,
        Register2Component,
        Register1Component,
        MapComponent,
        ModalRestorePasswordComponent,
        RestorePasswordComponent,
        UserFormModalComponent,
        RequireChurchComponent,
        InputTextComponent,
        ChurchAvatarPipe,
    ],
    imports: [
        BrowserModule,
        FlexLayoutModule,
        appRouting,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        HttpModule,
        ShareModule.forRoot(),
        appRouting
    ],
    providers: [
        GeneralService,
        LoadService,
        ValidatorService,
        FiltersService,
        LoginGuard,
        GuestGuard,
        ChurchService,
        RegistrationService,
        LoginService,
        MinisterService,
        IglesiasService,
        NotificationsService,
        RolesService,
        CredentialRenovationsService,
        PersoneriaJuridicaService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts